import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // No token: Redirect to login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // No role or invalid role: Redirect to login
  const validRoles = ["Superadmin", "Formateur", "Stagiaire"];
  if (!role || !validRoles.includes(role)) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    return <Navigate to="/" replace />;
  }

  // Role not allowed: Redirect based on role
  if (!allowedRoles.includes(role)) {
    const defaultPaths = {
      Superadmin: "/Dashboard",
      Formateur: "/FormateurDashboard",
      Stagiaire: "/StagiaireDashboard",
    };
    return <Navigate to={defaultPaths[role] || "/"} replace />;
  }

  // Authorized: Render children
  return children;
};

export default ProtectedRoute;